import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Task } from '../../../../types/task.interface';
import { CamundaService } from '../../../../service/camunda.service';
import { Store } from '@ngrx/store';
import { FluxBPMState } from '../../../../store/reducer/flux-bpm.reducers';
import { AbstractTemplateComponent } from '../../abstract/abstract-template.component';
import { NgIf } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'lib-flux-loading-step-template',
    templateUrl: './loading-template.component.html',
    styleUrls: ['./loading-template.component.scss'],
    imports: [NgIf, TranslatePipe],
    standalone: true
})
export class LoadingTemplateComponent extends AbstractTemplateComponent implements OnInit, OnDestroy {
    private timeoutHandle;
    public showCancelButton = false;
    private cancelButtonTimeout: any = null;

    constructor(
        protected camundaService: CamundaService,
        protected store: Store<FluxBPMState>
    ) {
        super(camundaService, store);
    }

    public taskUpdated(): void {
        // this.restartTimer();
    }

    ngOnInit(): void {
        this.config.showNextButton = false;
        this.config.showCancelButton = true;
        super.onInit(true);

        // Set timeout to show cancel button after 3 seconds
        this.cancelButtonTimeout = setTimeout(() => {
            this.showCancelButton = true;
        }, 3000);
    }

    restartTimer(): void {
        clearTimeout(this.timeoutHandle);
        this.timeoutHandle = setTimeout(() => {
            window.location.reload();
        }, 3000);
    }

    ngOnDestroy(): void {
        if (this.timeoutHandle) {
            // clearTimeout(this.timeoutHandle);
        }

        // Clear cancel button timeout if component is destroyed
        this.clearCancelButtonTimeout();
        super.ngOnDestroy();
    }

    private clearCancelButtonTimeout(): void {
        if (this.cancelButtonTimeout) {
            clearTimeout(this.cancelButtonTimeout);
            this.cancelButtonTimeout = null;
        }
    }

    nextTriggered(): void {
        // Clear timeout if process completes before 3 seconds
        this.clearCancelButtonTimeout();
        this.finishTask('', null, null);
    }

    cancelProcess(): void {
        if (this.cancelTrigger) {
            this.cancelTrigger.next(true);
        }
    }
}
